export default "/images/vendor/@coreui/icons/svg/flag/cif-ng.svg?eb6850b99b5e7c98c2596d5a2076df64";